<div class="app-footer d-flex align-items-center justify-content-between" [class.fixed-bottom]="settings.theme.footerIsFixed">
    <span class="social-icons">
    </span>
    <span class="copyright">Copyright © 2020 HGadvance</span>    
</div>